export default "__VITE_ASSET__9aef98eb__"